import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  scroll(event) {
    // Only handle standard left clicks
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    // Parse and resolve the link's absolute URL relative to the current page URL
    let url;
    try {
      url = new URL(this.element.href, window.location.href);
    } catch (e) {
      return;
    }

    // Check if the link targets the current page (same pathname and search query)
    const isSamePage =
      url.pathname === window.location.pathname &&
      url.search === window.location.search;

    if (isSamePage) {
      if (url.hash && url.hash !== "#") {
        let target;
        try {
          const decodedHash = decodeURIComponent(url.hash);
          target = document.querySelector(decodedHash);
        } catch (e) {
          return;
        }

        if (target) {
          // Prevent standard browser jump and scroll smoothly instead
          event.preventDefault();
          target.scrollIntoView({ behavior: "smooth" });

          // Dismiss the recent requests toast when scrolling to the form
          this.#dismissRecentRequests();
        }
      }
    } else {
      // If navigating to a different page/URL but the link contains an anchor hash,
      // save the target hash in sessionStorage so we can scroll smoothly after page load.
      if (url.hash && url.hash !== "#") {
        sessionStorage.setItem("scrollToHash", url.hash);
        sessionStorage.setItem("recentRequestsCTAClicked", "true");
      }
    }
  }

  #dismissRecentRequests() {
    const el = document.querySelector("[data-controller='recent-requests']");
    if (el) {
      const controller = this.application.getControllerForElementAndIdentifier(el, "recent-requests");
      if (controller) {
        controller.close();
      }
    }
  }
}
